import LeftNavActionButton from '@/components/common/pageLayout/LeftNavActionButton';
import { useAtomicStatus } from '@common/react/atomic';
import { getIdvStatusProps } from '@common/react/idv';
import Icon from '../common/icons/Icon';
import { showIDVStatusModal } from './IDVStatusModal';

const IDVStatusButton = () => {
    const atomicStatus = useAtomicStatus();
    if (!atomicStatus) return null;

    const statusProps = getIdvStatusProps(atomicStatus.status);
    if (!statusProps) return null;

    const { text, iconName, style } = statusProps;

    const iconColor = {
        error: 'red.500',
        info: 'gray.700',
    }[style];

    return (
        <LeftNavActionButton
            text={text}
            onClick={() => showIDVStatusModal()}
            icon={<Icon name={iconName} color={iconColor} />}
            onClickEvent="IDV Status Left Nav Action Button Clicked"
        />
    );
};

export default IDVStatusButton;
